//redux store from toolkit with redux-persist
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';

import storage from 'redux-persist/lib/storage';
import rootReducer from './slice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
  //non serializable check
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export const reduxStore = {
  store,
  persistor,
};
export default reduxStore;
